import { useState } from 'react';

const useHandleTags = () => {
    const [activeChips, setActiveChips] = useState([]);

    const handleChips = (chip) => {
        setActiveChips((activeChips) =>
            activeChips.includes(chip)
                ? activeChips.filter((ch) => ch !== chip)
                : [...activeChips, chip]
        );
    };

    return { activeChips, handleChips };
};

export default useHandleTags;
